<template>
  <div class="video-list">
    <div
      v-for="(video,index) in data"
      :key="index"
      class="video-item_wrap"
    >
      <video
        :src="video"
        class="video-item"
        preload="meta"
      ></video>
      <div
        class="video-mask"
        @click="previewVideo(video)"
      >
        <img
          src="@/assets/images/survey/stat/video.png"
          class="play-icon"
        />
      </div>
    </div>
  </div>
</template>

<script>
import preview from "./preview";
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    previewVideo(url) {
      preview.$emit("open-video", url);
    }
  }
};
</script>

<style lang="less" scoped>
.video-list {
  padding-top: 15px;
  display: flex;
  flex-wrap: wrap;
}
.video-item_wrap {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 5px 12.5px 5px 0;
  border-radius: 4px;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
}
.video-item {
  width: 100%;
  height: 100%;
}
.video-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100px;
  height: 100px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.play-icon {
  width: 30px;
  height: 30px;
}
</style>